import React from 'react';
import { useContext } from 'react';
import { Link } from 'react-router-dom';
import Context from '../context/Context';
import { handleInteractionBeacon } from '../helpers/handleInteractionBeacon';
import { buildDetailsPath } from '../helpers/deepLinks';
import { getTitleText, sanitizeTitle } from '../helpers/sanitizeTitle';

const SearchResult = (props) => {
    const { doc } = props;
    const { criteria, setCurrentDoc, screenWidth } = useContext(Context);

    return (
        <Link
            className="group block text-left rounded hover:bg-gray-100 transition ease-in-out mx-[-.75rem] px-[.75rem] my-[-.65rem] py-[.65rem]"
            to={buildDetailsPath({ q: criteria.q, start: criteria.start, rows: criteria.rows, url: doc.original_url })}
            title={getTitleText(doc.title)}
            onClick={(event) => {
                handleInteractionBeacon( 'cdcarchive-searchresult-link', 'o', event.type );
                setCurrentDoc(doc);
            }}
        >
            {/* Title and Archive date */}
            {doc.title && (
                <p className="text-md font-bold">
                    <span className="group-hover:underline text-blue-link" dangerouslySetInnerHTML={{ __html: sanitizeTitle(doc.title) }} />

                    {doc.date_archived_display && (
                        <small className="font-normal block md:inline md:ml-2">Archived {doc.date_archived_display.split(' ')[0]}</small>
                    )}
                </p>
            )}

            {/* URL */}
            {doc.original_url ? (
                <p className={`text-gray-500 text-sm`}>{doc.original_url}</p>
            ) : (
                <>
                    {doc.archive_url && <p className={`text-gray-500 text-sm`}>{doc.archive_url}</p>}
                </>
            )}

            {/* Description with truncating */}
            {doc.excerpt_txt && doc.excerpt_txt.length > 0 && (
                <>
                    {screenWidth < 768 ? (
                        <p className="text-gray mt-2">{doc.excerpt_txt.length < 150 ? doc.excerpt_txt : doc.excerpt_txt.slice(0, 150) + '...'}</p>
                    ) : (
                        <p className="text-gray mt-2">{doc.excerpt_txt.length < 300 ? doc.excerpt_txt : doc.excerpt_txt.slice(0, 300) + '...'}</p>
                    )}
                </>
            )}
        </Link>
    )
}

export default SearchResult;
